import { calendarDateOfUtcInstant } from '../dates/calendar-date.js';
/**
 * The calendar date of a date a user picked, such as `payment_date`. The API stores a picked day as
 * 00:00 UTC on that day (`parseStrictDate`), so its UTC date *is* the day chosen; converting it to
 * Pacific would move every payment a day back (settled-decisions-accounts-receivable.md).
 */
export function businessDateOfPickedDate(value) {
    return calendarDateOfUtcInstant(value);
}
//# sourceMappingURL=business-date-of-picked-date.js.map